import React from 'react';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import ApiPreviewSection from './components/ApiPreviewSection';
import PricingSection from './components/PricingSection';
import TestimonialsSection from './components/TestimonialsSection';
import UseCasesSection from './components/UseCasesSection';
import TechnicalSpecsSection from './components/TechnicalSpecsSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      
      <main>
        <HeroSection />
        <FeaturesSection />
        <ApiPreviewSection />
        <UseCasesSection />
        <TechnicalSpecsSection />
        <PricingSection />
        <TestimonialsSection />
        <CTASection />
      </main>
      
      <Footer />
    </div>
  );
};

export default LandingPage;